import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Image, Input, Modal, Result, Row, Select, Tooltip } from "antd";
import Message from "../common/Message";
import AuthService from "../auth/AuthService";
import config from "../config";
import { PostponeReasons } from "../common/Constants";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import qs from "query-string";
import { useNavigate } from "react-router-dom";



const Auth = new AuthService();

const CustomerModal = ({ isModalOpen, setIsModalOpen, message, mySignMessage, myNameMessage, setMessage, setMySignMessage, setMyNameMessage }) => {
    console.log('messsage', message);
  const { TextArea } = Input;
  const { Option } = Select;
  const navigate = useNavigate()

  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [isLoading, setIsLoading] = React.useState(false);
  

  const handleCancel = () => {
    setIsModalOpen(false);
    setMessage('')
    setMySignMessage('')
    setMyNameMessage('')
  };

  const handleClose = () => {
    var win = window.open("about:blank", "_self");
    win.close();
  };


  const handleOk = () => {
    let rand = Math.random() * 50;
  let str = " ";
  for (let i = 0; i < rand; i++) {
    str += " ";
  }
  setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        width={800}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        // title={"Order Submitted"}
        // style={{
        //     top: 20,
        // }}
        centered
        footer={[
          <Button
          size="large"
          onClick={handleCancel}
        >
          {'Go Back'}
        </Button>,
        (!message && !mySignMessage && !myNameMessage) && (
            <Button key="back" size="large" onClick={handleClose}>
              Close
            </Button>
          ),
            
          ]}
      >
        <>
        <Result
        status="success"
        title="Order Details Saved Successfully!"
        subTitle={
            <>
            <span>{(message || mySignMessage || myNameMessage) ? "Missing Info": "Everyting Good"}</span><br/>
            <span style={{ color: 'red'}}>{message? "- " +message : ""}</span><br/>
            <span style={{ color: 'red'}}>{myNameMessage? "- " +myNameMessage : ""}</span><br/>
            <span style={{ color: 'red'}}>{mySignMessage? "- " +mySignMessage : ""}</span>
            </>
        }
        />
            
        </>
      </Modal>
      <Message type={type} msg={loadMessage} />
    </>
  );
};

export default CustomerModal;
